/**
 * @config
 */
declare const  window: any;

export class EnvBaseConfig {
    public sit = false;
    public local = false;
    /**
     * Enable to load json file from /assets/json/
     * When a build is created with this flag set as true
     * All XHR requests will be loaded from json foolder if
     * if a file name exists with provided service name
     * See serc/shared/modules/cvs-http/local-cvs-http.interceptor.ts
     */
    public useJson = false;
    public debug = false;
    public isApp = false;
    public warranty = false;
    public production = false;
    public development = false;
    private debugId = 'QzQzMjE=';
    public currentEnvStack = 'qa2';
    public enableProdPreview = false;

    constructor() { }
  /**
   * Function  to get lower environment stack
   */
  getEnv(): string {
    let host = window.location.host;
    host = host.substr(0, 30);
    const parts = host.split('.');
    if (parts[0]) {
      const lowerEnv = parts[0].split('-');
      if (lowerEnv[1]) {
        return lowerEnv[1].toLowerCase();
      }
    }
    return '';
  }

}
